import config from "../../config"
import RequestService from "../RequestService"

const fetchCustomerWaiverByUuid = (uuid, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrlV2}/customer_waivers/uuid/${uuid}`, successCallback, failureCallback)
}

export default fetchCustomerWaiverByUuid;